import React from 'react';
import styles from './WhatsInItForYou.module.css'; // Importă fișierul CSS Module

const WhatsInItForYou = () => {
  return (
    <section className={styles.whatsinit}>
      <h2 className={styles.whatsinith2}>What's in it for you?</h2>

      <div className={styles.col4}>
        <div className={styles.what}>
          <p className={styles.whattitles}>Acces up to</p>
          <p className={styles.whattitlel}>90% <span className={styles.whattitlex}>Incentives</span></p>
          <p className={styles.whattitlecontent}>Save up to 90% of purchase and installation costs with Utility and State incentives.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Receive Customized</p>
          <p className={styles.whattitlel}>Financing <span className={styles.whattitlex}>Options</span></p>
          <p className={styles.whattitlecontent}>Enjoy a flexible payment plan and a seamless application process designed for your convenience.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Generate New</p>
          <p className={styles.whattitlel}>Revenue <span className={styles.whattitlex}>Streams</span></p>
          <p className={styles.whattitlecontent}>EV drivers earn double the national average. Give them a reason to visit.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Get up to</p>
          <p className={styles.whattitlel}>$100K <span className={styles.whattitlex}>Tax Credit</span></p>
          <p className={styles.whattitlecontent}>Your business may qualify for a generous tax credit, receive a 30% tax credit or up to $100k.</p>
        </div>

        <div className={styles.what}>
          <p className={styles.whattitles}>Be Prepared for the Future</p>
          <p className={styles.whattitlel}><span className={styles.whattitlex}>by</span> 2035</p>
          <p className={styles.whattitlecontent}>25% of gas stations will be out of work and 58% of new cars sales will be EVs by 2040.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Enjoy</p>
          <p className={styles.whattitlel}>30-60 <span className={styles.whattitlex}>More Minutes</span></p>
          <p className={styles.whattitlecontent}>Increase customer engagement and additional sales in your facility while charging their vehicles.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Stay</p>
          <p className={styles.whattitlel}>Ahead <span className={styles.whattitlex}>of the Curve</span></p>
          <p className={styles.whattitlecontent}>Invest in the rapidly expanding green energy ecosystem to future-proof your business.</p>
        </div>
        <div className={styles.what}>
          <p className={styles.whattitles}>Get Noticed</p>
          <p className={styles.whattitlel}><span className={styles.whattitlex}>by</span> 85% <span className={styles.whattitlex}>of EV Drivers</span></p>
          <p className={styles.whattitlecontent}>Ensure your location stands out to EV drivers using apps and on-line maps.</p>
        </div>
      </div>
    </section>
  );
};

export default WhatsInItForYou;
